import axios from 'axios';

// Base URL for the scraping service
const wsUrl = "https://deep-sage.softmining.it/ws.php";

/**
 * Sends the scraping request.
 * This function makes a POST request with serviceName "ENQUEUE_SCRAPE_REQUEST"
 * and expects the response "I have taken charge".
 */
export const enqueueScrapeRequest = async (IDD, GID, fileName) => {
    try {
        const response = await axios.post(
            wsUrl,
            {
                serviceName: "ENQUEUE_SCRAPE_REQUEST",
                IDD,
                GID,
                fileName
            },
            {
                headers: { "Content-Type": "application/json" }
            }
        );
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.error || error.message);
    }
};

/**
 * Checks the status of the scraping request.
 * This function makes a POST request with serviceName "SCRAPE_REQUEST_STATUS"
 * and returns the status.
 */
export const checkScrapeStatus = async (IDD, GID) => {
    try {
        const response = await axios.post(
            wsUrl,
            {
                serviceName: "SCRAPE_REQUEST_STATUS",
                IDD,
                GID
            },
            {
                headers: { "Content-Type": "application/json" }
            }
        );
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.error || error.message);
    }
};

/**
 * Retrieves the graph generated by the scraper.
 * This function makes a POST request with serviceName "GET_SCRAPE_OUTPUT".
 */
export const getScrapeOutput = async (IDD, GID) => {
    try {
        const response = await axios.post(
            wsUrl,
            {
                serviceName: "GET_SCRAPE_OUTPUT",
                IDD,
                GID
            },
            {
                headers: { "Content-Type": "application/json" }
            }
        );
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.error || error.message);
    }
};
